// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1351": "7664b242","6835": "70d3cba2","7198": "2c5f5214",}[chunkId] + ".css"
}